import { useEffect } from 'react';

const useColors = (backgroundColor, fontColor) => {
  useEffect(() => {
    document.body.style.backgroundColor = backgroundColor;
    document.body.style.color = fontColor;
  }, [backgroundColor, fontColor]);
};

export default useColors;